<fe-empty-container
    [containerClasses]="'mb-25'"
    [containerGutter]="'gx-5 gx-md-18'"
>
    <div class="row mb-6">
        <div class="col-12 gy-19">
            <span class="fe-empty-container-title fw-bold">{{
                'fe_precheckin_active_reservation_general_info_card_title'
                    | translate
            }}</span>
        </div>
    </div>
    <form [formGroup]="formActiveReservation">
        <div class="row">
            <div class="col-12 col-sm-6 mb-21">
                <fe-input
                    [formControlName]="'name'"
                    [autocomplete]="'dino-name'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_name'
                            | translate
                    "
                ></fe-input>
            </div>
            <div class="col-12 mb-21 col-sm-6">
                <fe-input
                    [formControlName]="'lastName'"
                    [autocomplete]="'dino-lastname'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_last_name'
                            | translate
                    "
                ></fe-input>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-21 col-sm-6">
                <fe-input
                    [formControlName]="'email'"
                    [autocomplete]="'dino-email'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_email'
                            | translate
                    "
                ></fe-input>
            </div>
            <div class="col-12 mb-21 col-sm-6">
                <fe-phone-lada-input
                    class="d-block"
                    [form]="formActiveReservation"
                    [ladaControlName]="'lada'"
                    [phoneControlName]="'phone'"
                    [autocomplete]="'dino-phone'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_phone'
                            | translate
                    "
                ></fe-phone-lada-input>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-21 col-sm-6">
                <fe-input
                    [formControlName]="'birthday'"
                    [formatDate]="inputDatePickerFormat"
                    [isDatepicker]="true"
                    [isSingleDatepicker]="true"
                    [isBirthday]="true"
                    [mask]="'00/00/0000'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_birthday'
                            | translate
                    "
                ></fe-input>
            </div>
        </div>
        <hr class="separator" />
        <div class="row mb-6">
            <div class="col-12">
                <span class="fe-empty-container-title fw-bold">{{
                    'fe_precheckin_active_reservation_general_info_address_title'
                        | translate
                }}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-21 col-sm-6">
                <fe-input
                    [formControlName]="'street'"
                    [autocomplete]="'dino-street'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_street'
                            | translate
                    "
                ></fe-input>
            </div>
            <div class="col-12 mb-21 col-sm-6">
                <fe-input
                    [formControlName]="'outdoorNumber'"
                    [autocomplete]="'dino-number'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_number'
                            | translate
                    "
                ></fe-input>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-21 col-sm-6">
                <fe-input
                    [formControlName]="'country'"
                    [isSelect]="true"
                    [id]="'country'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_country'
                            | translate
                    "
                    [items]="addressService.countries"
                    [selectType]="'typing'"
                    [loading]="loadingCountries"
                    (change)="onChangeCountry()"
                ></fe-input>
            </div>
            <div class="col-12 mb-21 col-sm-6">
                <fe-input
                    [formControlName]="'state'"
                    *ngIf="addressService.states.length === 0"
                    [autocomplete]="'dino-state'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_state'
                            | translate
                    "
                    [loading]="loadingStates"
                    [formControlName]="'state'"
                ></fe-input>
                <fe-input
                    *ngIf="addressService.states.length > 0"
                    [isSelect]="true"
                    [id]="'name'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_state'
                            | translate
                    "
                    [items]="addressService.states"
                    [formControlName]="'state'"
                    [selectType]="'typing'"
                    [loading]="loadingStates"
                    (change)="onChangeState()"
                ></fe-input>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-21 col-sm-6">
                <fe-input
                    *ngIf="addressService.cities.length === 0"
                    [id]="'name'"
                    [autocomplete]="'dino-city'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_city'
                            | translate
                    "
                    [loading]="loadingCities"
                    [formControlName]="'city'"
                ></fe-input>
                <fe-input
                    *ngIf="addressService.cities.length > 0"
                    [isSelect]="true"
                    [id]="'name'"
                    [items]="addressService.cities"
                    [formControlName]="'city'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_city'
                            | translate
                    "
                    [selectType]="'typing'"
                    [loading]="loadingCities"
                    (change)="onChangeCity()"
                ></fe-input>
            </div>
            <div class="col-12 mb-21 col-sm-6">
                <fe-input
                    *ngIf="addressService.neighborhoods.length === 0"
                    [id]="'name'"
                    [autocomplete]="'dino-neighborhood'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_neighborhood'
                            | translate
                    "
                    [loading]="loadingNeighborhoods"
                    [formControlName]="'neighborhood'"
                ></fe-input>
                <fe-input
                    *ngIf="addressService.neighborhoods.length > 0"
                    [isSelect]="true"
                    [id]="'name'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_neighborhood'
                            | translate
                    "
                    [items]="addressService.neighborhoods"
                    [formControlName]="'neighborhood'"
                    [selectType]="'typing'"
                    [loading]="loadingNeighborhoods"
                    (change)="onChangeNeighborhood()"
                ></fe-input>
            </div>
        </div>
        <div class="row">
            <div
                class="col-12 col-sm-6"
                [ngClass]="{ 'mb-25': !additionalDriver }"
            >
                <fe-input
                    [id]="'zipCode'"
                    [autocomplete]="'dino-zipcode'"
                    [label]="
                        'fe_precheckin_active_reservation_general_info_zipcode'
                            | translate
                    "
                    [disabled]="disabledZipCode"
                    [formControlName]="'zipCode'"
                    [mask]="'00000'"
                ></fe-input>
            </div>
        </div>
        <ng-container *ngIf="additionalDriver">
            <hr class="separator" />
            <div class="row mb-6">
                <div class="col-12">
                    <span class="fe-empty-container-title fw-bold">{{
                        'fe_precheckin_active_reservation_general_info_additional_driver_title'
                            | translate
                    }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-6 mb-21">
                    <fe-input
                        [formControlName]="'name2'"
                        [autocomplete]="'dino-name2'"
                        [label]="
                            'fe_precheckin_active_reservation_general_info_name'
                                | translate
                        "
                    ></fe-input>
                </div>
                <div class="col-12 mb-21 col-sm-6">
                    <fe-input
                        [formControlName]="'lastName2'"
                        [autocomplete]="'dino-lastname2'"
                        [label]="
                            'fe_precheckin_active_reservation_general_info_last_name'
                                | translate
                        "
                    ></fe-input>
                </div>
            </div>
            <div class="row">
                <div class="col-12 mb-21 col-sm-6">
                    <fe-input
                        [formControlName]="'email2'"
                        [autocomplete]="'dino-email2'"
                        [label]="
                            'fe_precheckin_active_reservation_general_info_email'
                                | translate
                        "
                    ></fe-input>
                </div>
                <div class="col-12 mb-21 col-sm-6 mb-25">
                    <fe-input
                        [formControlName]="'phone2'"
                        [autocomplete]="'dino-phone2'"
                        [label]="
                            'fe_precheckin_active_reservation_general_info_phone'
                                | translate
                        "
                        [mask]="'(000) 000-0000'"
                    ></fe-input>
                </div></div
        ></ng-container>
    </form>
</fe-empty-container>
